import { Component, Input, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { Transaction } from 'src/app/shared/models/transaction/transaction';
import { TransactionType } from 'src/app/shared/models/transaction/transaction-type';

@Component({
  selector: 'app-transaction-card-expanded',
  templateUrl: './transaction-card-expanded.component.html',
  styleUrls: ['./transaction-card-expanded.component.scss'],
})
/**
 * Expanded transaction card
 */
export class TransactionCardExpandedComponent implements OnInit {
  displayedColumns: string[] = [
    'code',
    'serial',
    'points',
    'addedby',
    'expiresOn',
  ];
  transactionExpandedLabels = {
    code: 'code',
    printerSerial: 'printer-serial',
    portPrinters: 'port-printers',
    points: 'points',
    totalPoints: 'total-points',
    expiration: 'expiration',
    expiredLabel: 'expired-on',
    expiresOn: 'expires-on',
    labelBy: 'label-by',
  };

  @Input() transactions!: Transaction[];
  @Input() sum!: number;
  @Input() loadingTransaction!: boolean;
  @Input() codesLabel!: string;
  language = '';
  transactionTypes = TransactionType;
  dateFormat?: string;

  /**
   * Constructor
   */
  constructor(private translationService: TranslationService) {}

  /**
   * Initator
   */
  ngOnInit() {
    this.translationService.translateObject(this.transactionExpandedLabels);
    this.language = this.translationService.getActiveLang();
    this.dateFormat = this.getDateFormatForLocale(this.language);
  }

  /**
   * Return format date using dots instead of slash based on language
   * @param {string} locale
   * @return {string}
   */
  private getDateFormatForLocale(locale: string): string {
    switch (locale) {
      case 'en':
        return 'MM.dd.yyyy';
      default:
        return 'dd.MM.yyyy';
    }
  }
}
